// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__9llQt","savePackageButton":"ClientWallet_savePackageButton__60QVe"};